// @ts-ignore
import { BUILD_VERSION } from "../versioning/version";

/**
 * Detect the client platform
 * @returns {string} The detected platform (win, mac, linux, ios, android, web)
 */
export const detectClientPlatform = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  // Check if running in Electron
  const isElectron = window.navigator.userAgent.indexOf("Electron") !== -1;

  if (isElectron) {
    // For Electron apps, use the platform from BUILD_VERSION
    return BUILD_VERSION.platform;
  }

  // For web browsers, detect OS
  if (userAgent.indexOf("win") !== -1) return "win";
  if (userAgent.indexOf("mac") !== -1) return "mac";
  if (userAgent.indexOf("linux") !== -1) return "linux";
  if (userAgent.indexOf("iphone") !== -1 || userAgent.indexOf("ipad") !== -1)
    return "ios";
  if (userAgent.indexOf("android") !== -1) return "android";

  return "web";
};
